<template>
    <ThemeProvider :theme="brandingState">
        <slot></slot>
    </ThemeProvider>
</template>
<script lang="ts">
    import { Component, Mixins } from 'vue-property-decorator';
    import ThemeProvider from '@/common/components/theme-provider/ThemeProvider.vue';
    import { BrandingMappedStoreMixin } from '@/common/store/branding/store';

    @Component({
        components: {
            ThemeProvider,
        },
    })
    export default class MainThemeProvider extends Mixins(BrandingMappedStoreMixin) {}
</script>
